import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import DatePicker from "react-datepicker";
import userApi from "api/userApi";
import { formatISOString } from "helpers/format";

export default function CreateEditCareer({
  setIsOpen,
  item,
  setItemToEdit,
  handleUpdateSuccess,
  userID,
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);

  const isEdit = item;

  const handleSubmit = async (values: any) => {
    if(!userID) return;

    try {
      setIsLoading((_prev) => true);
     
      const data = {
        ...values,
        startDate: values?.startDate
          ? formatISOString(values?.startDate)
          : null,
        endDate: values?.endDate
          ? formatISOString(values?.endDate)
          : null,
      };

      console.log(data)
      const response: any = isEdit
        ? await userApi?.postUserWorkingExperience(item?.id, data)
        : await userApi?.postUserWorkingExperience(userID, data);

      if (response?.data) {
        handleUpdateSuccess && handleUpdateSuccess();
        setIsLoading((_prev) => false);
        setIsOpen(false);
        toast(
          `${t("The career has been added.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`Please re-check your data`);
      return error;
    }
  };

  const validationSchema = Yup.object({
    workplace: Yup.string().required(`${t("This field is required")}`),
    position: Yup.string().required(`${t("This field is required")}`),
    startDate: Yup.string().required(`${t("This field is required")}`),
    endDate: Yup.string().required(`${t("This field is required")}`)
  });

  const formik = useFormik({
    initialValues: {
      workplace: "",
      position: "",
      description: "",
      startDate: null,
      endDate: null,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (item) {
      console.log(item);
      const formatedFile = item?.files?.map((i: any) => {
        return {
          uid: "-1",
          name: "image.png",
          url: i,
          thumbUrl: i,
          ...i,
        };
      });
      formik.setFieldValue("files", formatedFile);
      formik.setFieldValue(
        "name",
        item?.translations?.filter((i: any) => i?.lang == "ko")?.[0]?.name
      );
      formik.setFieldValue(
        "price",
        item?.prices?.filter((i: any) => i?.unit == "₩")?.[0]?.price
      );
    }
  }, [item]);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]);

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
        {isEdit ? t("Button Update Career") : t("Button Create Career")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <div className="mb-4">
          <Progress
            value={
              !isFirstProgress
                ? 100 - (100 / 4) * Number(Object.keys(formik.errors).length)
                : 0
            }
            color="primary"
            className="animated-progress progress-sm"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col md={6} lg={6}>
              <div className="mb-3">
                <Label htmlFor="workplace" className="form-label">
                  {t("Workplace")}
                  <span className="text-danger"> *</span>
                </Label>

                <div className="d-flex mb-2 gap-2 align-items-center">
                  <Input
                    name="workplace"
                    type="text"
                    className="form-control"
                    id="workplace"
                    placeholder={t("Workplace")}
                    value={formik?.values?.workplace || ""}
                    onChange={(event: any) =>
                      formik.setFieldValue("workplace", event?.target?.value)
                    }
                  />
                </div>

                {formik.touched.workplace && formik.errors.workplace ? (
                  <div className="text-danger mt-2">
                    {formik.errors.workplace}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={6} lg={6}>
              <div className="mb-3">
                <Label htmlFor="position" className="form-label">
                  {t("Position")}
                  <span className="text-danger"> *</span>
                </Label>

                <div className="d-flex mb-2 gap-2 align-items-center">
                  <Input
                    name="position"
                    type="text"
                    className="form-control"
                    id="position"
                    placeholder={t("Position")}
                    value={formik?.values?.position || ""}
                    onChange={(event: any) =>
                      formik.setFieldValue("position", event?.target?.value)
                    }
                  />
                </div>

                {formik.touched.position && formik.errors.position ? (
                  <div className="text-danger mt-2">
                    {formik.errors.position}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={6} lg={6}>
              <div className="mb-3">
                <Label htmlFor="startDate" className="form-label">
                  {t("Start Date")}
                  <span className="text-danger"> *</span>
                </Label>
                <div className="w-100">
                  <DatePicker
                    name={"preferred-contact-time"}
                    className="form-control w-100"
                    selected={formik?.values?.startDate}
                    placeholderText={t("Start Date")}
                    onChange={(date: any) => {
                      formik.setFieldValue("startDate", date);
                    }}
                    dateFormat="yyyy-MM-dd"
                    isClearable={true}
                  />
                </div>
                {formik.touched.startDate && formik.errors.startDate ? (
                  <div className="text-danger mt-2">
                    {formik.errors.startDate}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={6} lg={6}>
              <div className="mb-3">
                <Label htmlFor="endDate" className="form-label">
                  {t("End Date")}
                  <span className="text-danger"> *</span>
                </Label>
                <div className="w-100">
                  <DatePicker
                    name={"preferred-contact-time"}
                    className="form-control w-100"
                    selected={formik?.values?.endDate}
                    placeholderText={t("End Date")}
                    onChange={(date: any) => {
                      formik.setFieldValue("endDate", date);
                    }}
                    dateFormat="yyyy-MM-dd"
                    isClearable={true}
                  />
                </div>
                {formik.touched.endDate && formik.errors.endDate ? (
                  <div className="text-danger mt-2">
                    {formik.errors.endDate}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <Label htmlFor="description" className="form-label">
                  {t("Description")}
                </Label>

                <div className="d-flex mb-2 gap-2">
                  <textarea
                    className="form-control"
                    name={`description`}
                    maxLength={1000}
                    value={formik?.values?.description}
                    placeholder={`${t("Description")}`}
                    onChange={(event) => {
                      formik.setFieldValue(
                        `description`,
                        event?.target?.value
                      );
                    }}
                    style={{ height: 80 }}
                  />
                </div>

                {formik.touched.description && formik.errors.description ? (
                  <div className="text-danger mt-2">
                    {formik.errors.description}
                  </div>
                ) : null}
              </div>
            </Col>

            <div className="col-lg-12">
              <div className="hstack gap-2 justify-content-end">
                <button
                  className="btn btn-primary fs-14"
                  color="success"
                  type="submit"
                  disabled={isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) : (
                    <>{isEdit ? t("Button Update") : t("Button Create")}</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
